<script lang="ts">
  import { getProject } from "../services/api/data-handler.js";
  import type { Project } from "../services/api/types.js";
  import "ag-grid-enterprise";
  import ProjectCard from "../components/cards/ProjectCard.svelte";
  import DocumentExtract from "../components/extract/DocumentExtract.svelte";
  import ProjectExtract from "../components/extract/ProjectExtract.svelte";
  import { Splitpanes, Pane } from "svelte-splitpanes";

  export let id: string;
  let project: Project | undefined;
  let isInitialized = false;
  let splitPosition: number = 15;
  let activeView: "worksheet" | "document" | null = "worksheet";
  let selectedDocumentId: string = "";
  let selectedDocumentTitle: string = "Journal of Clinical Oncology";
  let selectedDocumentUrl: string = "/pdf/yRpV95gBW4DRgsiTb3fw.pdf";
  let selectedStudyName: string = "Study 1";

  $: if (id && !project && !isInitialized) {
    isInitialized = true;
    getProject(id).then((result) => {
      project = result.project;
      // Open worksheet by default when project loads
      activeView = "worksheet";
    });
  }

  function handleFullWorksheet() {
    activeView = "worksheet";
    selectedDocumentId = "";
  }

  function handleDocumentSelect(event: CustomEvent<{ documentId: string; documentTitle: string; documentUrl: string; studyName: string }>) {
    activeView = "document";
    selectedDocumentId = event.detail.documentId;
    selectedDocumentTitle = event.detail.documentTitle;
    selectedDocumentUrl = event.detail.documentUrl;
    selectedStudyName = event.detail.studyName;
  }
</script>

<div class="project-overview">
  <Splitpanes class="project-splitpanes" horizontal={false}>
    <Pane size={splitPosition} minSize={10} maxSize={40}>
      <!-- Project Card -->
      <div class="app-card project-card-pane">
        {#if project}
          <ProjectCard {project} on:fullWorksheet={handleFullWorksheet} on:documentSelect={handleDocumentSelect} />
        {/if}
      </div>
    </Pane>
    <Pane size={100 - splitPosition}>
      <!-- Right Panel Content -->
      <div class="project-content-pane">
        {#if activeView === "worksheet"}
          <div class="embedded-container">
            <ProjectExtract show={true} projectId={id} showExternalLink={true} />
          </div>
        {:else if activeView === "document" && selectedDocumentId}
          <div class="embedded-container">
            <DocumentExtract documentId={selectedDocumentId} documentTitle={selectedDocumentTitle} documentUrl={selectedDocumentUrl} studyName={selectedStudyName} showExternalLink={true} />
          </div>
        {:else}
          <div class="project-empty-state">
            <p>Select a document or open the Full Worksheet to view content</p>
          </div>
        {/if}
      </div>
    </Pane>
  </Splitpanes>
</div>
